import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  MatBottomSheet
} from '@angular/material/bottom-sheet';
import {
  MatLegacyDialog as MatDialog
} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { UserNotifyService } from 'src/app/core/notify/user-notify.service';
import { GetBannerService } from 'src/app/shared/services/api/banner/getbanners.service';
import { GetLessonsService } from 'src/app/shared/services/api/lesson/get_lessons.service';
import { QuestionsComponent } from 'src/app/views/partials/questions/questions.component';
import SwiperCore, {
  A11y,
  Autoplay,
  Controller,
  Navigation,
  Pagination,
  Scrollbar,
  SwiperOptions,
  Thumbs,
  Virtual,
  Zoom,
  Lazy
} from 'swiper';
import { GetBannerResponseModel } from '../../../../shared/api-models/responses/banner/GetBannerResponseModel';
import { IncreaseBannerClickService } from '../../../../shared/services/api/banner/increase_banner_click.service';
import { ScoreBottomSheetComponent } from '../../auth/score-bottom-sheet/score-bottom-sheet.component';
import { GetLeaderBoardDetailService } from './../../../../shared/services/api/LeaderBoard/get-leader-board-detail.service';
import { GetLeaderBoardService } from './../../../../shared/services/api/LeaderBoard/get-leader-board.service';
import { AuthService } from './../../auth/auth.service';
import { CourseListBottomSheetComponent } from './course-list-bottom-sheet/course-list-bottom-sheet.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { GetMainFreeCourseService } from 'src/app/shared/services/api/course/get_main_free_course.service';
import { environment } from 'src/environments/environment.prod';
import { GetNewsPostService } from 'src/app/shared/services/api/blog/get_news_service';
import { GetBannerModel } from 'src/app/shared/api-models/responses/banner/GetBannners';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
  Lazy
]);

@Component({
  selector: 'app-book-list',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {

  // @ViewChild(SwiperComponent) swiper?: SwiperComponent;
  @ViewChild('freeCourse') imgBox!: ElementRef;

  liveClassState: number;
  Scroll: number = 0;
  banners = [];
  ProfileDetail;
  profile_img;
  walletAmount;
  // defaultUrl: string = 'sys.azmoot.ir/api/v1/files/';
  showSkeleton: boolean = true;
  Goftino: String = 'https://www.goftino.com/widget/bt3Bfu';
  openDialog() {
    this.dialog.open(QuestionsComponent);
  }
  onOpenBottomSheet() {
    this.bottomSheet.open(ScoreBottomSheetComponent);
  }

  image: boolean = true;
  unsubscribes: Subscription[] = [];
  banner: [];
  baners;
  gridBanners;
  productItem;
  hotproductbanner;
  lessons;
  leaderBoards;
  heros;
  isLoading: boolean;
  boardTitle;
  slides: GetBannerResponseModel[];
  userLogin;
  loader: boolean = true;
  topstudentloader: boolean = true;
  leaderboardloader: boolean = true;
  datalink5;
  gradeId = 'e76f9105-07a3-4a10-91a7-08d856158a0d';
  showMobile: boolean;
  baseUrl;
  freeCourseLoader: boolean = true;
  loadingBlogList: boolean = true;

  blogList = [];
  mainFreeCourse = [];
  topContent = [];
  constructor(
    private bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    private getBannerService: GetBannerService,
    private increaseBannerClickService: IncreaseBannerClickService,
    private router: Router,
    private getLessonsService: GetLessonsService,
    private toast: UserNotifyService,
    private getleaderboard: GetLeaderBoardService,
    private getleaderboardDetail: GetLeaderBoardDetailService,
    private auth: AuthService,
    private breakpointObserver: BreakpointObserver,
    private getFreeCourseService: GetMainFreeCourseService,
    private getAllHighlightContentService: GetNewsPostService,

  ) {
    this.breakpointObserver.observe(['(max-width: 800px)'])
      .subscribe(result => {
        this.showMobile = result.matches;
      });
  }
  env;
  ngOnInit() {
    this.showSkletonsLoader()
    this.baseUrl = environment.paths.data
    this.getSlider('e76f9105-07a3-4a10-91a7-08d856158a0d');
    this.userLogin = this.auth.isAuthenticated().value;
    this.getLessons();
    this.getLeaderBoard();
    this.getFreeCourse();
    this.getBlogList('', '', 1, 20, true, false);
    this.getTopContent('', '', 1, 20, false, true);
  }
  showSkletonsLoader() {
    const initialBlogItemsCount = 1;
    for (let i = 0; i < 4; i++) {
      const itemSkeleton = {
        items: Array(initialBlogItemsCount).fill(null)
      };
      this.banners.push(itemSkeleton);
      this.blogList.push(itemSkeleton)
      this.mainFreeCourse.push(itemSkeleton)
      this.topContent.push(itemSkeleton)
    }
  }
  getFreeCourse() {
    const page_num = 1;
    const page_size = 6
    this.getFreeCourseService.call('', page_num, page_size, true).subscribe(res => {
      this.mainFreeCourse = res.items
      if (res) {
        setTimeout(() => {
          this.freeCourseLoader = false
        }, 500);
      }
    })
  }
  onGoToFreeCourse(item) {
    this.router.navigate(['course-detail'], { queryParams: { course: item.Id } })
  }
  getBlogList(profesorId?, courseId?, pageNum?, pageSize?, isNews?, IsTopContent?) {
    this.getAllHighlightContentService.call(profesorId, courseId, pageNum, pageSize, isNews, IsTopContent).subscribe((res) => {
      if (res) {
        this.blogList = res.items;
        setTimeout(() => {
          this.loadingBlogList = false
        }, 500);
      }
    });
  }
  onGoToBlogDetail(id) {
    this.router.navigate(['blog'], { queryParams: { id: id } });
  }
  handleTopContentClick(item) {
    this.onGoToBlogDetail(item.Id);
  }
  topContentLoader: boolean = true;
  getTopContent(profesorId, courseId, pageNum?, pageSize?, isNews?, IsTopContent?) {
    this.getAllHighlightContentService.call(profesorId, courseId, pageNum, pageSize, isNews, IsTopContent).subscribe((res) => {
      if (res) {

        this.topContent = res.items;
        setTimeout(() => {
          this.topContentLoader = false;
        }, 500);
      }
    });
  }
  onGoToTests() {
    this.router.navigate(['/seasons']);
  }
  onGoToPracticeExam() {
    this.router.navigate(['/practice-exam']);
  }
  comingSoon() {
    this.toast.showInfo('به زودی');
  }
  onOpenCourseListBottomSheet() {
    this.bottomSheet.open(CourseListBottomSheetComponent)
  }
  // Method to Get Slider API
  getSlider(gradeId) {
    this.getBannerService.call(gradeId, 1).subscribe(async (res) => {
      this.banners = [];

      if (res) {
        this.banners = res;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      }
    });
    this.getBannerService.call(gradeId, 5).subscribe((res) => {
      this.hotproductbanner = res;
    });

    this.topstudentloader = false;
  }
  // Method to Get Lessons API
  getLessons() {
    this.getLessonsService.call().subscribe((res) => {
      this.lessons = res;
    });
  }
  // clickOnBanner(model) {
  //   const banner = new BannerClick(
  //     model,
  //     this.increaseBannerClickService,
  //     this.router
  //   );
  //   banner.bannerClicked();
  // }
  getLeaderBoard() {
    this.getleaderboard.call().subscribe((res) => {
      this.leaderBoards = res;
      this.getLeaderBoardDetail(this.leaderBoards[0].id);
    });
  }
  getLeaderBoardDetail(id) {
    this.leaderboardloader = true;
    this.getleaderboardDetail.call(id).subscribe((res) => {
      this.heros = res;
      this.boardTitle = this.leaderBoards?.title;
      this.leaderboardloader = false;
    });
  }
  /**
   * on destroy life cycle
   * we unsubscribe all subscription here.
   */
  boxWidth;
  boxHeight;
  ngAfterViewInit() {
    this.boxHeight = this.imgBox.nativeElement.offsetHeight;
    this.boxWidth = this.imgBox.nativeElement.offsetWidth;
  }

  ngOnDestroy() {
    this.unsubscribes.forEach((x) => x.unsubscribe());
  }
}

// export class BannerClick {
//   constructor(
//     private model: GetBannerResponseModel,
//     private increaseBannerClickService: IncreaseBannerClickService,
//     private router: Router
//   ) { }
//   private gotoBook = () => {
//     this.router.navigate(['/seasons'], {
//       queryParams: { bookId: this.model.link_data_1.book_id },
//     });
//   };

//   private gotoWallet = () => {
//     this.router.navigate(['/wallet'], {
//       queryParams: {
//         amount: this.model.link_data_2.amount,
//         discount_code: this.model.link_data_2.discount_code,
//       },
//     });
//   };

//   private gotoExam = () => {
//     this.router.navigate(['/quiz'], {
//       queryParams: { examId: this.model.link_data_3.exam_id },
//     });
//   };

//   private gotoTest = () => {
//     this.router.navigate(['/quiz'], {
//       queryParams: { testId: this.model.link_data_4.test_id },
//     });
//   };

//   private customUrl = () => {
//     window.open(this.model.link_data_5.url);
//   };
//   // tslint:disable-next-line: member-ordering
//   private clickModel = {
//     1: this.gotoBook,
//     2: this.gotoWallet,
//     3: this.gotoExam,
//     4: this.gotoTest,
//     5: this.customUrl,
//   };
//   bannerClicked() {
//     this.increaseBannerClickService
//       .call({ banner_id: this.model.banner_id })
//       .subscribe(
//         (res) => { },
//         (err) => { }
//       );
//     this.clickModel[this.model.link_type]();
//   }
// }
